import { render, staticRenderFns } from "./FailShare.vue?vue&type=template&id=e147337c&scoped=true&"
import script from "./FailShare.vue?vue&type=script&lang=js&"
export * from "./FailShare.vue?vue&type=script&lang=js&"
import style0 from "./FailShare.vue?vue&type=style&index=0&id=e147337c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e147337c",
  null
  
)

export default component.exports